import { merge, of } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
export function clampIfStreemshotRequestWasFulfilled(streemshots) {
    return function (source) {
        return source.pipe(withLatestFrom(merge(of([]), streemshots)), filter(([latestRequest, streemshots]) => {
            return streemshots.every(ss => ss.id !== latestRequest.streemshotId);
        }), map(([latestRequest]) => latestRequest));
    };
}
//# sourceMappingURL=clamp_if_streemshot_request_was_fulfilled.js.map